"use strict";

var _classCallCheck = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NodeNames_1 = require("../enum/NodeNames");

var ParamNames_1 = require("../enum/ParamNames");

var AbstractAssign_1 = require("./abstract/AbstractAssign");

var GlobalNode =
/*#__PURE__*/
function (_AbstractAssign_1$def) {
  _inherits(GlobalNode, _AbstractAssign_1$def);

  function GlobalNode(token) {
    var _this;

    _classCallCheck(this, GlobalNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GlobalNode).call(this, NodeNames_1.default.Global, token));
    _this.params = _this.checkParams(token);

    if (_this.params.length === 1 && _this.params[0].type === ParamNames_1.default.Identifier) {
      _this.body = [];
    }

    return _this;
  }

  _createClass(GlobalNode, [{
    key: "isAssignmentExpressionSingle",
    value: function isAssignmentExpressionSingle(param, token) {
      if (param.type === ParamNames_1.default.Identifier) {
        return param;
      }

      return _get(_getPrototypeOf(GlobalNode.prototype), "isAssignmentExpressionSingle", this).call(this, param, token);
    }
  }, {
    key: "isAssignmentExpression",
    value: function isAssignmentExpression(param, token) {
      if (param.type === ParamNames_1.default.UpdateExpression && !param.prefix) {
        return param;
      }

      return _get(_getPrototypeOf(GlobalNode.prototype), "isAssignmentExpression", this).call(this, param, token);
    }
  }]);

  return GlobalNode;
}(AbstractAssign_1.default);

exports.default = GlobalNode;